"use strict";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
 // import ElementUI from 'element-ui'
 // import 'element-ui/lib/theme-chalk/index.css'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import 'normalize.css/normalize.css'
import '@/assets/iconfont/iconfont'
import '@/assets/icon/iconfont.css'//阿里icon
import {getToken,removeToken} from '@/utils/auth'
import VueLazyload from 'vue-lazyload'
import 'babel-polyfill';

import './icons'

Vue.config.productionTip = false

Vue.directive('title', {
    inserted: function (el, binding) {
        document.title = el.innerText;
        el.remove();
    }
})

// Vue.use(ElementUI, { locale })
// Vue.use(ElementUI);
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: 'http://img1.3lian.com/2015/a1/82/d/158.jpg',
    loading: 'http://h.hiphotos.baidu.com/zhidao/wh%3D450%2C600/sign=bf193fc3f8f2b211e47b8d4affb0490e/e824b899a9014c08c1277115097b02087bf4f466.jpg',
    attempt: 1
})

const whiteList = ['/login','/viewadcontent','/adcontent'];
router.beforeEach((to, from, next) => {
    NProgress.start();
    if (getToken()) {
        if (to.path === '/login') {
            next({path: '/'});
        } else {
            if (store.getters.roles.length === 0) {
                store.dispatch('fileTokenStore');
                store.dispatch('getUserRuleList').then(response => { // 拉取user_info
                    // roro
                    const { menus: roles } = response
                    if (roles) {
                    // if (response && response.getMenuModules) {
                        
                        // const roles = response.getMenuModules;

                        for(let i = 0;i < roles.length;i++){
                            roles[i].key = roles[i].url;
                        }

                        if(roles.length===0){
                            removeToken();
                            next({path: '/login'})
                            NProgress.done();
                        }else{

                            store.dispatch('GenerateRoutes', {roles}).then(() => { // 生成可访问的路由表
                                router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
                                next({...to}) // hack方法 确保addRoutes已完成
                            })
                        }

                    } else {
                        next({...to})
                        NProgress.done();
                    }
                }).catch(() => {
                    store.dispatch('FedLogOut').then(() => {
                        next({path: '/login'})
                        NProgress.done();
                    })
                })
            } else {
                next();
            }
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            next('/login');
            NProgress.done();
        }
    }
});

router.afterEach(() => {
    NProgress.done();
});

new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js